module.exports = __webpack_public_path__ + "static/rugbyshop-8ac7c3e66a9992612cc9bbee2309f9c7.png";